import { OryErrorMessageId, OryErrorNamedMessageId } from '../../types';

export function isOryInvalidCredentialsError(oryMessageId: OryErrorMessageId): boolean {
  return oryMessageId === OryErrorNamedMessageId.Login_flow_invalid_credentials_4000006;
}

export function isOrySessionRefreshRequiredError(oryMessageId: OryErrorMessageId): boolean {
  return oryMessageId === OryErrorNamedMessageId.Session_refresh_required;
}
